const Footer = () => {
    return (<div className='footer'>
    <p>Made with ❤️ from <a href='https://anusha-anilkumar.netlify.app/'>Anusha Anil Kumar</a></p>
  </div>);
  };
  
  export default Footer;








